<template>
    <div class="Background">
        <h2 class="Title">
            소셜 연동
        </h2>
        <v-card class="pa-5 mb-2" outlined>
            <v-row class="socialconnected">
                <div class="mr-3">
                    <v-img src="@/styles/youtube.png" width="50" class="mt-2 mr-1"/>
                </div>
                <div>
                    <h3>Youtube</h3>
                    <span class="type_txt">제목, 섬네일, 태그, 기재가 업로드 됩니다. </span>
                </div>
                <v-col class="text-right btn_position">
                    <!--connected 연결완료-->
                    <TextButton buttonText="connected" width="120px" />
                    <!--connecte 연결-->
                    <!-- <TextButton isPrimary buttonText="connect" width="120px" /> -->
                </v-col>
            </v-row>
        </v-card>

        <v-card class="pa-5 mb-2" outlined disabled>
            <v-row class="socialconnected">
                <div class="mr-3">
                    <v-img src="@/styles/facebook.png" width="50" class="mr-1"/>
                </div>
                <div>
                    <h3>FaceBook</h3>
                    <span class="type_txt">해당 서비스는 준비 중 입니다. </span>
                </div>
                <v-col class="text-right btn_position">
                    <TextButton isPrimary buttonText="connect" width="120px"/>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton2.vue';

export default {
    components: {
        TextButton
    },
    methods: {

    }
    
}
</script>

<style scoped>
.socialconnected{
    display: flex;
}
.socialconnected .type_txt{
    font-size: 14px;
    color: #888;
}
.socialconnected .btn_position{
    align-items: center;
    display: flex;
    justify-content: right;
}
</style>